import {useTranslation} from 'react-i18next'
import {ConfirmDialog} from '@/components/confirm-dialog'
import type {BateriaCierreResumen} from '@/hooks/bateria/use-bateria'

export function EvaluacionLifecycleDialogs({
  cerrando,
  onCerrandoChange,
  cierreResumen,
  cerrarPending,
  onConfirmarCerrar,
  entregando,
  onEntregandoChange,
  entregarPending,
  onConfirmarEntregar,
}: {
  cerrando: boolean
  onCerrandoChange: (open: boolean) => void
  cierreResumen: BateriaCierreResumen | undefined
  cerrarPending: boolean
  onConfirmarCerrar: () => void
  entregando: boolean
  onEntregandoChange: (open: boolean) => void
  entregarPending: boolean
  onConfirmarEntregar: () => void
}) {
  const {t} = useTranslation()
  return (
    <>
      <ConfirmDialog
        open={cerrando}
        onOpenChange={onCerrandoChange}
        title={t('admin.bateria.lifecycle.cerrarTitle')}
        description={
          cierreResumen && cierreResumen.sin_validar > 0
            ? t('admin.bateria.lifecycle.cerrarDescPendientes', {
                pendientes: cierreResumen.sin_validar,
                validados: cierreResumen.validados,
              })
            : t('admin.bateria.lifecycle.cerrarDesc')
        }
        confirmLabel={t('admin.bateria.lifecycle.cerrarConfirm')}
        cancelLabel={t('common.cancel')}
        pending={cerrarPending}
        onConfirm={onConfirmarCerrar}
      />

      <ConfirmDialog
        open={entregando}
        onOpenChange={onEntregandoChange}
        title={t('admin.bateria.lifecycle.entregarTitle')}
        description={t('admin.bateria.lifecycle.entregarDesc')}
        confirmLabel={t('admin.bateria.lifecycle.entregarConfirm')}
        cancelLabel={t('common.cancel')}
        pending={entregarPending}
        onConfirm={onConfirmarEntregar}
      />
    </>
  )
}
